module.exports = __webpack_public_path__ + "img/Delete.a5aa5fd9.svg";